import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import Icon from '~/components/Icon'
import { Text } from '~/components/ui/text'
import designTokens from '~/lib/designTokens'

export function PublicFrontPageBuyers() {
  const { t: tHome } = useTranslations('home')

  return (
    <View className="mx-3">
      <View className="relative z-20 w-full max-w-4xl gap-8 self-center rounded-content bg-primary px-5 py-16 sm:mx-auto sm:gap-10 sm:px-10 sm:py-24">
        <View className="size-18 absolute left-1/2 top-0 aspect-square -translate-x-1/2 -translate-y-1/2 flex-row items-center justify-center self-center rounded-full bg-muted">
          <Icon name="user-plus" size={30} color={designTokens.foreground} />
        </View>
        <View className="items-center gap-6">
          <Text className="text-center font-semibold text-2xl leading-tight tracking-tight text-background xs:text-3xl">
            {tHome(($) => $.frontpage.buyer.statementTitle)}
          </Text>
          <View>
            <Text className="text-pretty text-center font-light text-base leading-relaxed text-background sm:text-lg">
              {tHome(($) => $.frontpage.buyer.whySegment1)}
            </Text>
            <Text className="text-pretty text-center font-light text-base leading-relaxed text-background sm:text-lg">
              {tHome(($) => $.frontpage.buyer.whySegment2)}
            </Text>
          </View>
        </View>
      </View>
    </View>
  )
}
